import { useParams } from 'react-router-dom';
import { useCallback, useEffect } from 'react';
import { Loader } from '@/components/Common/Loader';
import { PoweredByAppcharge } from '@/components/Footer/PoweredByAppcharge';
import { stripeService } from '@/services/stripe';

export const StripePaymentHandlerPage = () => {
  const { publishableKey, clientSecret } = useParams();

  const handleStripeAction = useCallback(async (publishableKey: string, clientSecret: string) => {
    const stripe = await stripeService.createStripeInstance(publishableKey || '');
    stripeService.initialize(stripe);
    await stripe.handleNextAction({ clientSecret });
    window.close();
  }, []);

  useEffect(() => {
    if (publishableKey && clientSecret) {
      handleStripeAction(publishableKey, clientSecret);
    }
  }, [publishableKey, clientSecret]);

  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex-1 flex items-center justify-center">
        <Loader />
      </div>
      <div className="pb-4">
        <PoweredByAppcharge />
      </div>
    </div>
  );
};
